<div
  [ngClass]="'desktop-carousel carousel-parent ' + backgroundColor"
  data-automation-id="carouselSectionDesktop"
>
  <div class="container">
    <div class="carousel-header" data-automation-id="carouselText">
      <digital-platform-rsx-rich-text
        *ngIf="richTextTitle"
        [body]="richTextTitle"
      ></digital-platform-rsx-rich-text>

      <div
        class="header-right-container"
        data-automation-id="cta-arrows-right-section"
      >
        <digital-platform-cta-button
          *ngIf="ctaButton && ctaButton.length > 0"
          [analyticsLinkText]="ctaButton![0].analyticsLinkText || null"
          [chevron]="ctaButton![0].chevron"
          [ctaPosition]="ctaButton![0].ctaPosition || null"
          data-automation-id="explore-cta-button-desktop"
          [ctaSize]="ctaButton![0].ctaSize || null"
          [ctaStyle]="ctaButton![0].ctaStyle || null"
          [ctaWidth]="ctaButton![0].ctaWidth || null"
          [fontAwesomeIconClass]="ctaButton![0].fontAwesomeIconClass || null"
          [marginBottomClass]="ctaButton![0].marginBottomClass"
          [marginTopClass]="ctaButton![0].marginTopClass"
          [url]="ctaButton![0].url"
          [visibility]="ctaButton![0].visibility"
        ></digital-platform-cta-button>

        <div *ngIf="isScrollable" class="scroll-button-container">
          <a
            role="button"
            (click)="scrollLeft()"
            [attr.data-analytics-text]="'insights-previous'"
            data-automation-id="link-scroll-left"
          >
            <digital-platform-icon
              [class.disabled-icon]="!canScrollLeft()"
              icon="chevron-left-circle"
              data-automation-id="leftArrow"
              color="#d80025"
            ></digital-platform-icon>
          </a>

          <a
            role="button"
            (click)="scrollRight()"
            [attr.data-analytics-text]="'insights-next'"
            data-automation-id="link-scroll-right"
          >
            <digital-platform-icon
              [class.disabled-icon]="!canScrollRight()"
              icon="chevron-right-circle"
              data-automation-id="rightArrow"
              color="#d80025"
            ></digital-platform-icon>
          </a>
        </div>
      </div>
    </div>

    <div
      class="carousel-cards-shell flipped"
      data-automation-id="carousel-cards-shell"
      [class.no-scrollbar]="!isScrollable"
      #carouselContent
      (scroll)="onScroll()"
    >
      <div *ngFor="let card of cardsCarouselCard" class="card-wrapper">
        <div style="width: {{ imageWidthDesktop }}px;">
          <digital-platform-cards-carousel-card
            data-automation-id="digital-platform-cards-carousel-card"
            [carouselCardType]="card.carouselCardType"
            [ctaButton]="card.ctaButton"
            [inlineImage]="card.inlineImage"
            [richTextTitle]="card.richTextTitle"
            [svgIconClass]="card.svgIconClass"
            [bgColor]="card.bgColor"
            [angularConfig]="card.angularConfig"
          ></digital-platform-cards-carousel-card>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  [ngClass]="'mobile-carousel mobile-carousel-parent ' + backgroundColor"
  data-automation-id="carouselSectionMobile"
>
  <!-- Services Available -->
  <div *ngIf="showAccordion">
    <div class="mobile-carousel-header border-bottom-0">
      <digital-platform-rsx-rich-text
        *ngIf="richTextTitle"
        [body]="richTextTitle"
      ></digital-platform-rsx-rich-text>
      <div
        class="mobile-header-right"
        data-automation-id="explore-cta-button-mobile"
      >
        <div>
          <a
            role="button"
            type="button"
            data-automation-id="toggle-button"
            (click)="showCards = !showCards"
            *ngIf="!showCards"
          >
            <digital-platform-icon
              icon="chevron-down"
              class="normalize-icon-sizing expand-icon fill-red"
            ></digital-platform-icon>
          </a>
          <a
            role="button"
            type="button"
            data-automation-id="toggle-button"
            (click)="showCards = !showCards"
            *ngIf="showCards"
          >
            <digital-platform-icon
              icon="chevron-up"
              class="normalize-icon-sizing expand-icon fill-red"
            ></digital-platform-icon>
          </a>
        </div>
      </div>
    </div>

    <div [@accordionOpenClose]="showCards" *ngIf="showCards">
      <div
        class="center-card-container"
        data-automation-id="mobile-cards-container"
      >
        <div
          class="services-card-container w-100"
          *ngFor="let card of cardsCarouselCard"
        >
          <digital-platform-cards-carousel-card
            [richTextTitle]="card.richTextTitle"
          ></digital-platform-cards-carousel-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Insights and Information -->
  <div *ngIf="!showAccordion">
    <div class="mobile-carousel-header">
      <digital-platform-rsx-rich-text
        *ngIf="richTextTitle"
        [body]="richTextTitle"
      ></digital-platform-rsx-rich-text>
      <div class="mobile-header-right">
        <digital-platform-cta-button
          *ngIf="ctaButton && ctaButton.length > 0"
          [analyticsLinkText]="ctaButton![0].analyticsLinkText || null"
          [chevron]="ctaButton![0].chevron"
          [ctaPosition]="ctaButton![0].ctaPosition || null"
          [ctaSize]="ctaButton![0].ctaSize || null"
          [ctaStyle]="ctaButton![0].ctaStyle || null"
          [ctaWidth]="ctaButton![0].ctaWidth || null"
          [fontAwesomeIconClass]="ctaButton![0].fontAwesomeIconClass || null"
          [marginBottomClass]="ctaButton![0].marginBottomClass"
          [marginTopClass]="ctaButton![0].marginTopClass"
          [url]="ctaButton![0].url"
          [visibility]="ctaButton![0].visibility"
        ></digital-platform-cta-button>
      </div>
    </div>

    <div>
      <div class="center-card-container">
        <ng-container *ngFor="let card of cardsCarouselCard">
          <digital-platform-cards-carousel-card
            class="card-container col-sm-12"
            (click)="navigate(card.ctaButton![0].url, $event)"
            [carouselCardType]="card.carouselCardType"
            [ctaButton]="card.ctaButton"
            [inlineImage]="card.inlineImage"
            [richTextTitle]="card.richTextTitle"
            [svgIconClass]="card.svgIconClass"
            [angularConfig]="card.angularConfig"
          ></digital-platform-cards-carousel-card>
        </ng-container>
      </div>
    </div>
  </div>
</div>
